import {qs} from '../qs'

const BASE_PATH = '/hysplit'

export default {
  step1: (trjtype, query) => ({
    url: `${BASE_PATH}/mfile/${trjtype}${qs(query, '?')}`,
    method: 'GET'
  }),
  step2: (taskId, query) => ({
    url: `${BASE_PATH}/select/mfile/${taskId}?mfile=${encodeURIComponent(query.mfile)}`,
    method: 'GET'
  }),
  step3: (taskId, query) => ({
    url: `${BASE_PATH}/calculate/${taskId}${qs(query, '?')}`
  }),
  step4: (taskId, query) => ({
    url: `${BASE_PATH}/over/${taskId}${qs({
      url: query.url
    }, '?')}`
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/HYSPLIT.js